import { useNavigate } from "react-router-dom";
import { Pickaxe } from "lucide-react";
// const navigate = useNavigate();
interface IEmpty {
  msg: string;
  showBack?: boolean;
}
export const Empty = ({ msg, showBack }: IEmpty) => {
  const navigate = useNavigate();
  return (
    <div className="container">
      <div className="text-center position-absolute top-50 start-50 translate-middle">
        <div>
          <Pickaxe size={120} strokeWidth={1} className="no-fill mt-2" />
        </div>
        <div className="fs-3 py-2">{msg}</div>
        <br />
        {showBack !== false && (
          <button
            className="btn btn-primary"
            onClick={() => {
              navigate(-1);
            }}
          >
            back
          </button>
        )}
      </div>
    </div>
  );
};
